import { DatePicker, Form } from 'antd';
import { useFormikContext } from 'formik';
import moment from 'moment';
import { FormLabel } from './FormLabel';

interface Props {
  fieldName: string;
  label: string;
}

export const DateInput = ({ fieldName, label, ...rest }: Props): JSX.Element => {
  const { handleBlur, handleChange, values, errors, touched } = useFormikContext<any>();

  return (
    <Form.Item
      hasFeedback
      labelAlign="left"
      validateStatus={errors[fieldName] ? 'error' : 'success'}
      label={<FormLabel label={label} />}
      help={touched[fieldName] ? errors[fieldName] : undefined}
      labelCol={{ style: { padding: 0 } }}
      style={{ marginBottom: 0 }}>
      <DatePicker
        {...rest}
        format={'MM/DD/YYYY'}
        value={values[fieldName] ? moment(values[fieldName]) : undefined}
        onChange={(_, dateString): void => handleChange(fieldName)(dateString)}
        onBlur={handleBlur(fieldName)}
        style={{ width: '100%' }}
      />
    </Form.Item>
  );
};
